import React from "react";
import { Header, Image } from "semantic-ui-react";
import Picture from "../Home/Blank.png";
import { Link } from "react-router-dom";

 
const PageHeader = props => (
  <Header as='h3' icon textAlign='center'>
      <Image size="massive" src={Picture} centered className="PageHeaderImage" as={Link} to="/"  />
      <Header.Content>
        {props.Name}
        <Header.Subheader className="PageHeaderSub">
          {props.Description}
        </Header.Subheader>
      </Header.Content>
  </Header>
)
export default PageHeader;